<template>
  <popup v-model="visible" size="sm" class="popup-claim-pdf">
    <slide-toggle>
      <div v-if="done" :key="'success'" class="popup-claim-pdf__success">
        <div class="font-h1" v-html="$t('popupClaimPdf.success.title')"></div>
        <div
          v-html="$t('popupClaimPdf.success.text', { email: formData.email })"
        ></div>
      </div>
      <form v-else class="popup-claim-pdf__form" @submit.prevent="onSubmit">
        <div class="font-h1 u-text-center" v-html="$t('popupClaimPdf.title')"></div>
        <div class="font-text u-text-center" v-html="$t('popupClaimPdf.text')"></div>
        <div class="popup-claim-pdf__form_input">
          <Input
            v-model="$v.formData.email.$model"
            :label="$t('popupClaimPdf.label')"
            :disabled="pending"
            :error="$v.formData.email.$error"
          />
        </div>
        <div class="popup-claim-pdf__form_button">
          <yt-button
            tag="button"
            type="submit"
            :disabled="pending || $v.formData.$error"
          >
            {{ $t("popupClaimPdf.button") }}
          </yt-button>
        </div>
        <div class="font-text-small u-text-secondary u-text-center" v-html="$t('common.terms')"></div>
      </form>
    </slide-toggle>
  </popup>
</template>

<script>
import Popup from "@/components/ui-kit/popup/index.vue";
import SlideToggle from "@/components/ui-kit/slide-toggle/index.vue";
import Input from "@/components/ui-kit/yt-input/index.vue";
import { mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import getVuelidateErrorMessage from "@/assets/js/utils/get-vuelidate-error-message";
import getBackendErrorMessage from "@/assets/js/utils/get-backend-error-message";
import { axiosOffers } from "@/services/scopes/axios-offers";
import YtButton from "@/components/ui-kit/yt-button";

export default {
  components: {
    Popup,
    SlideToggle,
    Input,
    YtButton,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    tourId: {
      type: [String, Number],
      required: true,
    },
    offerId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      formData: {
        email: "",
      },
      pending: false,
      backendErrorMessage: "",
      done: false,
    };
  },
  validations: {
    formData: {
      email: {
        required,
        email,
      },
    },
  },
  computed: {
    ...mapState("user", { userEmail: (user) => user.email }),
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
    emailError() {
      console.log(this.$v.formData.email);
      return this.$v.formData.email.$error
        ? this.getVuelidateErrorMessage(this.$v.formData.email)
        : this.backendErrorMessage;
    },
  },
  watch: {
    formData: {
      deep: true,
      handler() {
        this.backendErrorMessage = "";
      },
    },
    visible(visible) {
      if (!visible && this.done) {
        this.pending = false;
        this.done = false;
        this.formData.email = "";
        this.$v.formData.$reset();
      }
    },
  },
  created() {
    this.formData.email = this.userEmail || "";
  },
  methods: {
    async onSubmit() {
      this.$v.formData.$touch();

      if (this.pending || this.$v.formData.$invalid) {
        return;
      }

      this.pending = true;

      await axiosOffers
        .sendBrochureOfOffer(this.tourId, this.offerId, this.formData.email)
        .then(() => {
          this.done = true;
        })
        .catch((error) => {
          this.backendErrorMessage = this.getBackendErrorMessage(error);
          this.pending = false;
        });
    },
    getVuelidateErrorMessage,
    getBackendErrorMessage,
  },
};
</script>

<style lang="scss" scoped>
.yt_input {
  width:100%;
}
.popup-claim-pdf {
  &__form,
  &__success {
    > * + * {
      margin-top: 20px;
    }
  }
  &__form_button {
    button {
      width:100%;
    }
  }
  &__form_input {
    .yt_input {
      width:100%;
    }
  }
}
</style>
